import Cookies from 'js-cookie';
import { sendIdentify } from './identify.js';

// Fallback list, only used if the `unlkClickIdParams` global (set via the
// "Click ID List" customizer setting, wp_localize_script'd in functions/setup.php) is unavailable.
const DEFAULT_CLICK_ID_PARAMS = [
  'pvd_cid', 'ttd_id', 'ttclid', 'last_ad_visit', 'clickid', 'clid', 'sp_camp',
  'latest_user_agent', 'latest_ip', 'rr_wcid', 'last_touch_source', 'dnclkid',
  'first_touch_source', 'rdt_cid', 'gbraid', 'wbraid', 'tblci', 'evrflwid', 'fbclid'
];

export function getClickIdParams() {
  return Array.isArray(globalThis.unlkClickIdParams) && globalThis.unlkClickIdParams.length > 0
    ? globalThis.unlkClickIdParams
    : DEFAULT_CLICK_ID_PARAMS;
}

export function getClickIds(search = globalThis.location?.search) {
  const params = new URLSearchParams(search);
  const found = {};

  for (const param of getClickIdParams()) {
    if (params.has(param)) {
      found[param] = params.get(param);
    }
  }

  return found;
}

const SESSION_KEY = 'unlk_click_id_identified';

// Segment JSON-encodes these cookie values (e.g. `"abc123"`), so unwrap the quotes.
function readSegmentCookie(name) {
  const raw = Cookies.get(name);
  if (!raw) return;

  try {
    return JSON.parse(raw);
  } catch {
    return raw;
  }
}

function identifyClickId() {
  if (globalThis.sessionStorage?.getItem(SESSION_KEY)) return;

  const clickIds = getClickIds();
  if (Object.keys(clickIds).length === 0) return;

  // ajs_user_id is only set once a known user has been identified elsewhere (e.g. form
  // submit); ajs_anonymous_id is Segment's own visitor id and is applied automatically
  // when no userId is passed, so we only need to read the former here.
  const userId = readSegmentCookie('ajs_user_id');

  sendIdentify(userId, clickIds);

  try {
    globalThis.sessionStorage?.setItem(SESSION_KEY, '1');
  } catch {
    // sessionStorage unavailable (private mode, etc.) — fall through, identify still fired
  }
}

if (globalThis.analytics && typeof globalThis.analytics.ready === 'function') {
  // eslint-disable-next-line no-undef
  analytics.ready(identifyClickId);
} else {
  document.addEventListener('DOMContentLoaded', identifyClickId);
}
